import React, { useState } from 'react';

const EORCalculator = ({ countryName }) => {
  const [formData, setFormData] = useState({
    contractedRate: '',
    pension: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Your message has been sent!');
    setFormData({
      contractedRate: '',
      pension: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    });
  };

  return (
    <div className="contactUsEor_container">
      <div className="contactUs_content">
        {/* Left Section */}
        <div className="contactUs_info Cal-calculator">
          <div className="contactUs_formWrapper">
            <h1>{countryName} Salary Calculator</h1>
            <form className="contactUs_form" onSubmit={handleSubmit}>
              <div className="contactUs_formRow">
                <input
                  type="text"
                  name="contractedRate"
                  value={formData.contractedRate}
                  onChange={handleChange}
                  placeholder="Contracted Rate £ (£)"
                  required
                  className="contactUs_input"
                />
              </div>

              <div className="contactUs_formRow">
                <select
                  name="pension"
                  value={formData.pension}
                  onChange={handleChange}
                  required
                  className="contactUs_input"
                >
                  <option value="" disabled>
                    Select Pension Option
                  </option>
                  <option value="in">Opt in</option>
                  <option value="out">Opt out</option>
                </select>
              </div>
            </form>
          </div>
        </div>

        {/* Right Section */}
        <div className="contactUs_formWrapper">
          <form className="contactUs_form" onSubmit={handleSubmit}>
            <h1>Submit the form</h1>
            <div className="contactUs_formRow">
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
                required
                className="contactUs_input"
              />
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                required
                className="contactUs_input"
              />
            </div>
            <div className="contactUs_formRow">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address"
                required
                className="contactUs_input"
              />
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                required
                className="contactUs_input"
              />
            </div>

            <button type="submit" className="contactUs_button">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};


export default EORCalculator;
